import React from 'react';
import '../common/FloatingAssistWidget.css';
import './SettingsAutoSaveWidget.css';

const DEFAULT_DURATION_MS = 5000;

export interface SettingsAutoSaveWidgetProps {
  visible: boolean;
  saving: boolean;
  /** Bump to restart the countdown animation and timer in the parent */
  timerKey: number;
  durationMs?: number;
  onCancel: () => void;
  onSaveNow: () => void;
}

const SettingsAutoSaveWidget: React.FC<SettingsAutoSaveWidgetProps> = ({
  visible,
  saving,
  timerKey,
  durationMs = DEFAULT_DURATION_MS,
  onCancel,
  onSaveNow,
}) => {
  if (!visible) {
    return null;
  }

  const countdownActive = !saving;
  const countdownSec = Math.round(durationMs / 1000);

  return (
    <div className="settings-autosave-root" role="region" aria-label="Auto-save settings">
      <div
        className="settings-autosave__frame"
        style={{ ['--autosave-duration' as string]: `${durationMs}ms` }}
      >
        <div
          key={timerKey}
          className={`settings-autosave__ring${saving ? ' settings-autosave__ring--paused' : ''}`}
          aria-hidden="true"
        />
        <div className="settings-autosave__card">
          <div className="settings-autosave__header">
            <span className="settings-autosave__title">Auto-save</span>
            <span className="settings-autosave__status">
              {saving ? 'Saving…' : `Saving in ${countdownSec}s`}
            </span>
          </div>
          <div className="settings-autosave__separator" role="presentation" />
          <div className="settings-autosave__actions">
            <button
              type="button"
              className="floating-assist__action-btn settings-autosave__btn settings-autosave__btn--cancel"
              onClick={onCancel}
              disabled={saving}
              aria-label="Discard changes and do not save"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
            <button
              type="button"
              className={`floating-assist__action-btn settings-autosave__btn settings-autosave__btn--save${
                countdownActive ? ' settings-autosave__btn--save-active' : ''
              }`}
              onClick={onSaveNow}
              disabled={saving}
              aria-label="Save changes now"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
                <polyline points="20 6 9 17 4 12" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsAutoSaveWidget;
